import { alpha, createTheme, darken, lighten } from '@mui/material/styles';
import baseTheme from './theme';

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export const isTenantBrandedPath = (pathname: string): boolean => {
  const normalized = pathname.toLowerCase();
  return normalized === '/'
    || normalized === '/book-now'
    || normalized === '/myappointment';
};
export const createTenantTheme = (themeConfig?: {
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  textColor: string;
}) => {
  if (!themeConfig || !Object.values(themeConfig).every((color) => HEX_COLOR.test(color))) {
    return baseTheme;
  }

  const paletteColor = (main: string) => ({
    main,
    light: lighten(main, 0.2),
    dark: darken(main, 0.2),
    contrastText: baseTheme.palette.getContrastText(main),
  });

  return createTheme(baseTheme, {
    palette: {
      primary: paletteColor(themeConfig.primaryColor),
      secondary: paletteColor(themeConfig.secondaryColor),
      background: {
        default: themeConfig.backgroundColor,
        paper: themeConfig.backgroundColor,
      },
      text: {
        primary: themeConfig.textColor,
        secondary: alpha(themeConfig.textColor, 0.7),
        disabled: alpha(themeConfig.textColor, 0.45),
      },
      action: {
        hover: alpha(themeConfig.textColor, 0.08),
        selected: alpha(themeConfig.textColor, 0.14),
        disabled: alpha(themeConfig.textColor, 0.38),
        disabledBackground: alpha(themeConfig.textColor, 0.12),
      },
    },
  });
};
